import { render, staticRenderFns } from "./PageLayoutOne.vue?vue&type=template&id=5a87b514&"
import script from "./PageLayoutOne.vue?vue&type=script&lang=js&"
export * from "./PageLayoutOne.vue?vue&type=script&lang=js&"
import style0 from "./PageLayoutOne.vue?vue&type=style&index=0&id=5a87b514&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports